import { formatDate } from '@clim/client-core';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Empty } from '../components/ui';
import { useEngine } from '../lib/session';

/** Notifications internes (dépôts et signatures du client, …) — synchronisées, lisibles hors ligne. */
export function NotificationsPage() {
  const engine = useEngine();
  const navigate = useNavigate();
  const list = engine.list('notification').sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  const [perm, setPerm] = useState(typeof Notification === 'undefined' ? 'unsupported' : Notification.permission);
  return (
    <section>
      <h1>Notifications</h1>
      {perm === 'default' && (
        <p>
          <button className="btn small" onClick={() => void Notification.requestPermission().then(setPerm)}>
            Afficher les notifications importantes sur cet ordinateur
          </button>
        </p>
      )}
      {list.length === 0 && <Empty>Aucune notification.</Empty>}
      <ul className="list">
        {list.map((n) => (
          <li key={n.id}>
            <button
              className={`row${n.readAt ? '' : ' unread'}`}
              onClick={() => {
                void engine.markNotificationRead(n.id);
                if (n.link) navigate(n.link);
                else if (n.dossierId) navigate(`/dossiers/${n.dossierId}`);
              }}
            >
              <span className="row-main">
                <strong>
                  {n.readAt ? '' : '● '}
                  {n.title}
                </strong>
                <span className="muted">
                  {n.body ? `${n.body} · ` : ''}
                  {formatDate(n.createdAt)}
                </span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
